import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { SITE } from "@/lib/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-slate-950 text-slate-300"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <a href="#top" className="inline-flex items-center">
              <img
                src="/kola-logo-white.png"
                alt="Kola Gebäudereinigung"
                className="h-16 w-auto select-none"
                draggable="false"
              />
            </a>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-slate-400">
              Familiengeführte, professionelle Gebäudereinigung in Bayern und
              Baden-Württemberg. Zuverlässig, gründlich, persönlich erreichbar.
            </p>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">
              Kontakt
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-sky-400" />
                {SITE.address}
              </li>
              <li>
                <a
                  href={SITE.phoneHref}
                  data-testid="footer-phone"
                  className="flex items-start gap-3 hover:text-sky-300 transition-colors"
                >
                  <Phone className="w-4 h-4 mt-0.5 text-sky-400" /> {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={SITE.emailHref}
                  data-testid="footer-email"
                  className="flex items-start gap-3 hover:text-sky-300 transition-colors"
                >
                  <Mail className="w-4 h-4 mt-0.5 text-sky-400" /> {SITE.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">
              Navigation
            </div>
            <ul className="mt-5 space-y-3 text-sm">
              {[
                ["/#leistungen", "Leistungen"],
                ["/#warum", "Warum uns"],
                ["/#ablauf", "Ablauf"],
                ["/#referenzen", "Referenzen"],
                ["/#kontakt", "Kontakt"],
                ["/#faq", "FAQ"],
              ].map(([h, l]) => (
                <li key={h}>
                  <a
                    href={h}
                    className="hover:text-sky-300 transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
          <div>© {year} {SITE.name}. Alle Rechte vorbehalten.</div>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
            <Link to="/impressum" data-testid="footer-impressum" className="hover:text-sky-300">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-sky-300">Datenschutz</Link>
            <span className="hidden sm:block w-px h-3 bg-white/15" />
            <span className="text-slate-500">
              Diese Website wurde von{" "}
              <a
                href="https://weblinn.de"
                target="_blank"
                rel="noopener noreferrer"
                className="font-semibold text-slate-300 hover:text-sky-300 transition-colors"
              >
                Weblinn
              </a>{" "}
              gestaltet.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
